import { useTranslation } from "react-i18next";
import { useContext, useState } from "react";
import {defaultDrug, hospitalLanguages} from "../../../resources/json/jsons";
import { Consts } from "../../pages/consts";
import useMmcService from "../../../services/MmcService";
import InitContext from "../../pages/InitContext";
import ErrorMessage from "../../errorMessage/ErrorMessage";
import Spinner from "../../spinner/Spinner";
import SpecifyNewDrug from "../../drugs/SpecifyNewDrug";
import StrengthAndStartDate from "../../drug/StrengthAndStartDate";

const Drug = ({
                onHandleAddDrug,
                setOpenDrugRow,
                allProductNames,
                allSubstances,
                showDialog,
                patDrugs
              }) => {
  const { t } = useTranslation();
  const [myDrug, setMyDrug] = useState({...defaultDrug, intakes: Consts.DEFAULT_DAY_TIME_INTAKES});
  const [startDate, setStartDate] = useState("");
  const [strengthUnit, setStrengthUnit] = useState("");
  const [strength, setStrength] = useState(0);
  const context = useContext(InitContext);
  const { error, loading, getDrugBySubstancesJson } = useMmcService();
  const [messageText, setMessageText] = useState("");
  const language = hospitalLanguages[context?.patient?.study_id];

  const saveDrug = () => {
    onHandleAddDrug({
      ...myDrug,
      productName: myDrug?.productName ? myDrug?.productName : "",
      activeSubstance: myDrug?.activeSubstance ? myDrug?.activeSubstance : ""
    });
  };

  const resetFields = () => {
    setMessageText("");
    setMyDrug(defaultDrug);
    setStrength(0);
    setStrengthUnit("");
    setStartDate("");
  }

  const handleStrength = (value) => {
    setStrength(value);
    setMyDrug({ ...myDrug, strength: value });
  };

  const handleStrengthUnit = (value) => {
    setStrengthUnit(value);
    setMyDrug({ ...myDrug, strengthUnit: value });
  };

  const handleStartDate = (value) => {
    setStartDate(value);
    setMyDrug({ ...myDrug, startDate: value });
  };

  const handleSetFreeDrugDetails = (detailsName, value) => {
    setMessageText("");

    if(detailsName === Consts.PRODUCT){
      setMyDrug({ ...myDrug, productName: value });
    } else if(detailsName === Consts.SUBSTANCE){
      const cleanedSubstanceArr = value?.split(",")?.map(item => item.trim())?.filter(item => item !== "");

      getDrugBySubstancesJson(context?.token, cleanedSubstanceArr.join("&&&"), language)
        .then(resultDrug => {
          if(resultDrug?.atc){
            setMyDrug({ ...myDrug,
              activeSubstance: cleanedSubstanceArr, atc: resultDrug?.atc,  abda: resultDrug?.abda});
          } else {
            setMyDrug({ ...myDrug, activeSubstance: cleanedSubstanceArr});
          }
        }
      ).catch((err) => {
        console.error("handleOtherSubstance, err", err.message);
        setMyDrug({ ...myDrug, activeSubstance: cleanedSubstanceArr });
      })
    }
  }

  const handleSetMyDrug = (newDrug) => {
    setMessageText("");
    setMyDrug({...newDrug, intakeType: myDrug?.intakeType });
  }

  const errorMessage = error || (messageText && <ErrorMessage message={messageText} />);
  const spinner = loading && <Spinner />;

  let enableSubmit =  (myDrug?.productName !== "" || myDrug?.activeSubstance !== "")
    && myDrug?.startDate && myDrug?.startDate !== ""
    && myDrug?.strength && myDrug?.strength > 0
    && myDrug?.strengthUnit && myDrug?.strengthUnit !== "";

  return (
    <div
      className="w3-modal"
      style={{ display: showDialog ? Consts.BLOCK : Consts.NONE }}
    >
      <div className="w3-modal-content w3-card-4 w3-animate-zoom form-panel dialog-medium">
        <header className="w3-container w3-padding-small w3-center">
          <p>{t("add_new_medicine")}</p>
        </header>
        <div className="w3-container">
          <SpecifyNewDrug
            patDrugs={patDrugs}
            allProductNames={allProductNames}
            allSubstances={allSubstances}
            onSetSelectedDrug={handleSetMyDrug}
            resetFields={resetFields}
            setMessageText={setMessageText}
            setStrength={setStrength}
            setStrengthUnit={setStrengthUnit}
            handleSetFreeDrugDetails={handleSetFreeDrugDetails}
            init={true}
            language={language}
          />
          {errorMessage}
          {spinner}
          <StrengthAndStartDate
            strength={strength}
            onHandleStrength={handleStrength}
            strengthUnit={strengthUnit}
            onHandleStrengthUnit={handleStrengthUnit}
            startDate={startDate}
            onHandleStartDate={handleStartDate}
          />
        </div>
        <footer className="w3-container w3-padding-small">
          <p className="w3-right">
            <button
              className={enableSubmit
                  ? "w3-btn w3-round-xlarge w3-theme-d5"
                  : "w3-btn w3-round-xlarge w3-theme-d5 w3-disabled"
              }
              onClick={saveDrug}
            >
              {t("submit")}
            </button>
            <button
              className="w3-btn w3-round-xlarge w3-theme-d5 w3-margin-left"
              onClick={() => setOpenDrugRow(false)}
            >
              {t("cancel")}
            </button>
          </p>
        </footer>
      </div>
    </div>
  );
};

export default Drug;